import { create } from 'zustand';
import {
  LocalPaymentOptionsTypes,
  LocalPaymentOptionsState,
} from './interfaces';

const useLocalPaymentOptionsStore = create<LocalPaymentOptionsState>()(
  (set) => ({
    paymentOption: null,
    mixPayments: {
      CASH: 0,
      CARD: 0,
    },
    actions: {
      setPaymentOption: (to: LocalPaymentOptionsTypes) =>
        set({ paymentOption: to }),
      setMixPayments: ({ CASH, CARD }: { CASH?: number; CARD?: number }) => {
        set({
          mixPayments: {
            CASH,
            CARD,
          },
        });
      },
      cleanValues: () => {
        set({
          paymentOption: null,
          mixPayments: {
            CASH: 0,
            CARD: 0,
          },
        });
      },
    },
  }),
);

export const useLocalPaymentOption = () =>
  useLocalPaymentOptionsStore((state) => {
    return {
      paymentOption: state.paymentOption,
      mixPayments: state.mixPayments,
    };
  });

export const useLocalPaymentOptionsActions = () =>
  useLocalPaymentOptionsStore((state) => state.actions);
